import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "banner_img" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bannerMargin" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("兑换")
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "leftImg anima",
  style: {"width":"25%"}
}, null, -1)
const _hoisted_7 = { style: {"letter-spacing":"-2px","width":"20%","text-align":"center"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "moneyIcon" }, "￥", -1)
const _hoisted_9 = { class: "moneyNumber" }
const _hoisted_10 = {
  class: "rightContent",
  style: {"width":"55%"}
}
const _hoisted_11 = { class: "couponTitle" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = { class: "time" }
const _hoisted_14 = { class: "number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.memberId == 546)
      ? (_openBlock(), _createBlock(_component_van_nav_bar, {
          key: 0,
          title: "",
          "left-text": "生成书房券",
          "right-text": "兑换记录",
          onClickLeft: _ctx.createBookShopNumber,
          onClickRight: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goUrl())),
          class: "title"
        }, null, 8, ["onClickLeft"]))
      : (_openBlock(), _createBlock(_component_van_nav_bar, {
          key: 1,
          title: "",
          "right-text": "兑换记录",
          onClickRight: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goUrl())),
          class: "title"
        })),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createVNode(_component_van_cell_group, {
          inset: "",
          class: "bookshop-nav"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              class: "send_comment",
              style: { height: '6vh' },
              modelValue: _ctx.bookNumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bookNumber) = $event)),
              autosize: "",
              type: "textarea",
              placeholder: "请输入丹阳书房兑换码"
            }, {
              button: _withCtx(() => [
                _createVNode(_component_van_button, {
                  size: "small",
                  type: "warning",
                  class: "send_btn",
                  onClick: _ctx.bookNumberExchange
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coupLists, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "coupList",
          key: index,
          onClick: ($event: any) => (_ctx.jumpInfo(item.couponId))
        }, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(item.subMoney), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(item.couponName), 1),
            _createElementVNode("div", _hoisted_12, " 抢券时间:" + _toDisplayString(item.startTime) + " 10:01 ", 1),
            _createElementVNode("div", _hoisted_13, " 使用时间:" + _toDisplayString(item.useStartTime) + "-" + _toDisplayString(item.useEndTime), 1),
            _createElementVNode("div", _hoisted_14, "余" + _toDisplayString(item.quantity) + "张", 1)
          ])
        ], 8, _hoisted_5))
      }), 128))
    ])
  ]))
}